import { BondInfoType } from '../../constants';
import { ModalConfig } from '../../types';

const InfoContent: Record<BondInfoType, ModalConfig> = {
  [BondInfoType.UNSPECIFIED]: {
    title: 'Informasi Tidak tersedia',
    content: [],
  },
  [BondInfoType.ACCRUED_INTEREST]: {
    title: 'Kupon Berjalan',
    content: [
      <span>
        <b>Sebelum kupon pertama diterima:</b>
        <br />
        Kupon yang kamu bayar pada saat pembelian + Kupon Harian yang akan kamu
        terima pada kupon date selanjutnya.
      </span>,

      <span>
        <b>Sesudah kupon pertama diterima:</b>
        <br />
        Total kupon harian dari tanggal pembagian kupon terakhir hingga tanggal
        hari ini.
      </span>,
    ],
  },
  [BondInfoType.ACCRUED_INTEREST_SELLER]: {
    title: 'Kupon Penjual',
    content: [
      'Kupon yang perlu dibayarkan oleh pembeli sebagai hak yang harus diterima oleh penjual.',
      'Nominal kupon ini akan kamu terima kembali pada tanggal pencairan kupon berikutnya atau ketika kamu menjual unit kamu.',
    ],
  },
  [BondInfoType.CAPITAL_GAIN_LOSS]: {
    title: 'Capital Gain / Loss',
    content: [
      'Capital Gain = Nilai Sekarang - Modal Investasi',
      'Merupakan keuntungan atau kerugian dari selisih nilai sekarang dan modal investasi jika kamu menjual obligasi FR kamu pada saat ini.',
    ],
  },
  [BondInfoType.PNL_UNREALIZED]: {
    title: 'P&L (Unrealized)',
    content: [
      'P&L = Kupon Berjalan + Capital Gain',
      'Total keuntungan atau kerugian yang akan kamu dapatkan ketika kamu melakukan penjualan saat ini belum termasuk pajak dan bea materai.',
      'Perhitungan P&L (Unrealized) tidak termasuk total kupon yang sudah kamu terima sebelumnya',
    ],
  },
  [BondInfoType.TOTAL_DAILY_COUPON]: {
    title: 'Total Kupon Harian',
    content: [
      'Total kupon yang merupakan hak kamu yang diakumulasi setiap hari dari tanggal pembelian termasuk kupon yang telah kamu terima.',
      'Namun tidak menghitung kupon berjalan yang kamu bayarkan pada saat pembelian.',
    ],
  },
  [BondInfoType.TOTAL_INVESTMENT_PROFIT]: {
    title: 'Total Keuntungan Selama Investasi',
    content: [
      'Total Keuntungan = Total Kupon Harian + Capital Gain',
      'Total keuntungan (selama investasi) merupakan seluruh keuntungan/kerugian selama kamu memegang obligasi FR ini.',
      'Total keuntungan tersebut merupakan seluruh kupon yang telah/akan kamu terima dan Capital Gain / Loss pada saat penjualan saat ini.',
    ],
  },
  [BondInfoType.TOTAL_UNIT]: {
    title: 'Total Unit Obligasi',
    content: ['1 Unit Obligasi senilai dengan Rp1,000,000'],
  },
  [BondInfoType.PROJECTED_RETURN]: {
    title: 'Proyeksi Return',
    content: ['Proyeksi keuntungan dari investasi kamu pada saat jatuh tempo'],
  },
  [BondInfoType.PNL_NETT]: {
    title: 'P&L (Nett)',
    content: [
      'P&L = Kupon Berjalan + Capital Gain - Pajak',
      'Total keuntungan atau kerugian yang akan kamu dapatkan ketika kamu melakukan penjualan saat ini yang sudah termasuk pajak dan bea meterai.',
    ],
  },
  [BondInfoType.TOTAL_PROFIT_NETT]: {
    title: 'Total Keuntungan (Nett)',
    content: [
      'Total Keuntungan = Total Kupon Harian + Capital Gain',
      'Total keuntungan (selama investasi) merupakan seluruh keuntungan/kerugian selama kamu memegang obligasi FR ini.',
      'Total keuntungan tersebut merupakan seluruh kupon yang telah/akan kamu terima dan Capital Gain / Loss pada saat penjualan saat ini.',
    ],
  },
  [BondInfoType.BUYING_PRICE]: {
    title: 'Harga Beli',
    content: [
      'Harga indikatif (dalam satuan persentase) yang mengindikasikan harga beli Obligasi di Pasar Sekunder saat ini.',
    ],
  },
  [BondInfoType.SELLING_PRICE]: {
    title: 'Harga Jual',
    content: [
      'Harga indikatif (dalam satuan persentase) yang mengindikasikan harga jual Obligasi di Pasar Sekunder saat ini.',
    ],
  },
  [BondInfoType.PROFIT]: {
    title: 'Keuntungan',
    content: [
      'Keuntungan dihitung berdasarkan pergerakan harga dari produk Obligasi FR.',
    ],
  },
  [BondInfoType.CASH_ON_HAND]: {
    title: 'Cash on Hand',
    content: [
      'Saldo RDN yang telah mengalami Siklus Penyelesaian T+2 hari bursa.',
    ],
  },
  [BondInfoType.TAX]: {
    title: 'Pajak',
    content: [
      'Pajak sebesar 10% dikenakan dari nilai capital gain unit FR yang kamu jual. Penjualan kamu tidak dikenakan pajak apabila kamu sedang mengalami kerugian.',
    ],
  },
  [BondInfoType.BOND_TAX]: {
    title: 'Pajak Obligasi',
    content: [
      'Pajak sebesar 10% dikenakan dari nilai capital gain unit FR yang kamu jual. Penjualan kamu tidak dikenakan pajak apabila kamu sedang mengalami kerugian.',
    ],
  },
  [BondInfoType.USER_COUPON]: {
    title: 'Kupon Hak Kamu',
    content: [
      'Kupon Hak Kamu = Kupon Diterima - Kupon Penjual',
      'Total kupon diterima yang merupakan hak kamu setelah dikurangi kupon yang kamu bayarkan kepada penjual pada saat pembelian.',
    ],
  },
};

export default InfoContent;
